var $ = jQuery.noConflict();

// ==========================================
// JUDGEME CAROUSEL - Inject product thumbnail into no-media review cards
// For cards with class jm-carousel-review-item--no-media, clone the img
// from .jm-product-variant-card__thumbnail and prepend into .jm-carousel-review-item__body
// ==========================================
function injectProductThumbnailIntoNoMediaCards(container) {
    var $root = container ? $(container) : $('#judgeme_product_reviews');
    if ($root.length === 0) return;

    $root.find('.jm-carousel-review-item--no-media').each(function() {
        var $card = $(this);

        // Skip if already processed
        if ($card.hasClass('sg-thumb-injected')) return;

        var $body = $card.find('.jm-carousel-review-item__body');
        if ($body.length === 0) return;

        var $thumbFrame = $card.find('.jm-product-variant-card__thumbnail');
        var $highlightThumb = $card.find('.jm-highlight-thumbnail');
        
        // If neither primary thumbnail nor highlight thumbnail exists, try fallback
        if ($thumbFrame.length === 0 && $highlightThumb.length === 0) {
            // Fallback: get first img src from .productView-image[data-index="1"]
            var $productImg = $('.productView-image[data-index="1"] img').first();
            if ($productImg.length === 0) return;
            
            var originalSrc = $productImg.attr('src');
            if (!originalSrc) return;
            
            // Add width parameter to src
            var modifiedSrc = originalSrc + '&width=720';
            
            // Get product title for alt text
            var productTitle = $('h1.productView-title').first().text().trim() || '';
            
            // Create img element with required attributes
            var $img = $('<img>').attr({
                src: modifiedSrc,
                alt: productTitle,
                loading: 'lazy',
                decoding: 'async',
                fetchpriority: 'low'
            });
            
            // Create container with sg-cloned-product-thumb class (consistent with other cases)
            var $thumbDiv = $('<div class="sg-cloned-product-thumb"></div>').append($img);
            
            // Prepend into the review body
            $body.prepend($thumbDiv);
            $card.addClass('sg-thumb-injected');
            return;
        }
        
        // Use primary thumbnail if it exists, otherwise use highlight thumbnail
        var $selectedThumb = $thumbFrame.length > 0 ? $thumbFrame : $highlightThumb;

        var $img = $selectedThumb.find('img').first();
        if ($img.length === 0) return;

        // Clone the container first before modifying
        var $clonedThumb = $selectedThumb.clone();

        // Modify the image src inside the clone (not the original DOM)
        var srcVal = $clonedThumb.find('img').first().attr('src');
        if (srcVal) {
            $clonedThumb.find('img').first().attr('src', srcVal + '&width=720');
        }
        $clonedThumb.addClass('sg-cloned-product-thumb');
        $clonedThumb.removeClass('jm-product-variant-card__thumbnail');
        $clonedThumb.removeClass('jm-highlight-thumbnail');

        // Prepend into the review body (before the star rating cluster)
        $body.prepend($clonedThumb);
        $card.addClass('sg-thumb-injected');
    });
}

// Run immediately if #judgeme_product_reviews already exists
if (document.getElementById('judgeme_product_reviews')) {
    injectProductThumbnailIntoNoMediaCards();
}

// MutationObserver: watch for #judgeme_product_reviews being added/populated
if (typeof MutationObserver !== 'undefined') {
    var jmCarouselObserver = new MutationObserver(function(mutations) {
        var shouldProcess = false;

        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType !== 1) return;
                    // Check if the reviews container itself was added
                    if (node.id === 'judgeme_product_reviews') {
                        shouldProcess = true;
                    }
                    // Check if carousel review items were added inside the container
                    if (node.classList && (
                        node.classList.contains('jm-carousel-review-item') ||
                        node.classList.contains('jm-carousel__track') ||
                        node.classList.contains('jm-carousel')
                    )) {
                        shouldProcess = true;
                    }
                    if (node.querySelector && (
                        node.querySelector('.jm-carousel-review-item') ||
                        node.querySelector('#judgeme_product_reviews')
                    )) {
                        shouldProcess = true;
                    }
                });
            }
            // Also detect attribute changes (JudgeMe marks widget as done)
            if (mutation.type === 'attributes' && mutation.target) {
                var target = mutation.target;
                if (target.id === 'judgeme_product_reviews' ||
                    (target.classList && target.classList.contains('jm-carousel__track'))) {
                    shouldProcess = true;
                }
            }
        });

        if (shouldProcess) {
            clearTimeout(window.sgJmCarouselObserverTimer);
            window.sgJmCarouselObserverTimer = setTimeout(function() {
                console.log('[sg-product] JudgeMe carousel observer - injecting product thumbnails');
                injectProductThumbnailIntoNoMediaCards();
                truncateJdgmReviewBodies();
            }, 200);
        }
    });

    // Observe body for late-loading of the reviews widget
    var observeTarget = document.getElementById('judgeme_product_reviews') || document.body;
    jmCarouselObserver.observe(observeTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-widget-name', 'data-impressions-tracked', 'class']
    });

    // If we started observing body and the reviews container loads later,
    // re-attach observer to the container once found for better performance
    if (observeTarget === document.body) {
        var jmContainerWatcher = new MutationObserver(function(mutations) {
            var $reviews = document.getElementById('judgeme_product_reviews');
            if ($reviews) {
                jmContainerWatcher.disconnect();
                // Also observe the reviews container directly
                jmCarouselObserver.observe($reviews, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class', 'data-impressions-tracked']
                });
                // Run immediately
                setTimeout(function() {
                    injectProductThumbnailIntoNoMediaCards();
                }, 100);
            }
        });
        jmContainerWatcher.observe(document.body, { childList: true, subtree: false });
    }
}

// Also run on jdgm.doneSetup and window load as fallback
document.addEventListener('jdgm.doneSetup', function() {
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 300);
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 1000);
});

window.addEventListener('load', function() {
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 500);
    setTimeout(function() { injectProductThumbnailIntoNoMediaCards(); }, 2000);
});

// Disconnect observers on page unload to prevent memory leaks
window.addEventListener('beforeunload', function() {
    if (typeof jmCarouselObserver !== 'undefined') {
        jmCarouselObserver.disconnect();
    }
    if (typeof jdgmObserver !== 'undefined') {
        jdgmObserver.disconnect();
    }
});

// Additional fallback: Use MutationObserver to detect when Judge.me reviews are added
if (typeof MutationObserver !== 'undefined') {
    var jdgmObserver = new MutationObserver(function(mutations) {
        var hasNewReviews = false;
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && (node.classList.contains('jdgm-rev') || node.classList.contains('jdgm-rev-widg'))) {
                            hasNewReviews = true;
                        }
                        if (node.querySelector && node.querySelector('.jdgm-rev')) {
                            hasNewReviews = true;
                        }
                    }
                });
            }
        });
        
        if (hasNewReviews) {
            clearTimeout(window.jdgmObserverTimer);
            window.jdgmObserverTimer = setTimeout(function() {
                console.log('Judge.me MutationObserver detected reviews - processing');
                processJudgeMeReviewsGlobal();
                truncateJdgmReviewBodies();
            }, 300);
        }
    });
    
    // Start observing document body for Judge.me content
    if (document.body) {
        jdgmObserver.observe(document.body, { childList: true, subtree: true });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            jdgmObserver.observe(document.body, { childList: true, subtree: true });
        });
    }
}

// Interval-based fallback for Firefox - check periodically for unprocessed reviews
var intervalCheckCount = 0;
var intervalMaxChecks = 20; // Check for 10 seconds max
var jdgmIntervalCheck = setInterval(function() {
    intervalCheckCount++;
    
    // Check if there are unprocessed reviews
    var $unprocessedReviews = $('.jdgm-rev').filter(function() {
        return !$(this).find('.jdgm-rev__media.sg-processed').length && 
               $(this).find('.jdgm-rev__media').length > 0;
    });
    
    if ($unprocessedReviews.length > 0) {
        console.log('Judge.me interval check found unprocessed reviews - processing');
        processJudgeMeReviewsGlobal();
    }
    
    // Stop checking after max attempts or if all are processed
    if (intervalCheckCount >= intervalMaxChecks || $unprocessedReviews.length === 0) {
        clearInterval(jdgmIntervalCheck);
    }
}, 500);

// Global processing function that can be called from multiple paths
function processJudgeMeReviewsGlobal() {
    $('.jdgm-rev').each(function() {
        var $review = $(this);
        var $media = $review.find('.jdgm-rev__media');
        var $header = $review.find('.jdgm-rev__header');
        
        // Hide the media container with inline style
        if ($media.length > 0 && !$media.hasClass('sg-processed')) {
            $media.attr('style', 'display: none !important');
            $media.addClass('sg-processed');
        }
        
        // Check if cloned image already exists as DIRECT child
        var $existingClone = $review.children('.cloned-review-image');
        if ($existingClone.length > 0) {
            return;
        }
        
        // Remove any misplaced clones
        $review.find('.jdgm-rev__media .cloned-review-image').remove();
        
        // Find the first pic link in media container
        var $firstPicLink = $media.find('a.jdgm-rev__pic-link').first();
        
        if ($firstPicLink.length > 0 && $header.length > 0) {
            var $clonedPicLink = $firstPicLink.clone();
            $clonedPicLink.addClass('cloned-review-image');
            $clonedPicLink.removeClass('jdgm--loading');
            $clonedPicLink.find('img').each(function() {
                var $img = $(this);
                var currentSrc = $img.attr('src');
                var currentDataSrc = $img.attr('data-src');
                
                // Determine the best source URL (prefer data-src for lazy loaded images)
                var imageUrl = currentDataSrc || currentSrc;
                
                if (imageUrl) {
                    // Update to higher resolution
                    imageUrl = imageUrl.replace('w=160', 'w=600');
                    
                    // Always set both src and data-src to ensure image loads
                    $img.attr('src', imageUrl);
                    $img.attr('data-src', imageUrl);
                    
                    // Remove lazy loading class if present
                    $img.removeClass('lazyload lazy');
                }
            });
            $header.before($clonedPicLink);
        }
    });
    
    // Also add rating value if not present
    var $summary = $('#judgeme_product_reviews .jdgm-rev-widg__summary');
    if ($summary.length > 0) {
        var summaryText = $summary.text().trim();
        var ratingMatch = summaryText.match(/^(\d+\.?\d*)/);
        if (ratingMatch) {
            var rating = ratingMatch[1];
            var $summaryInner = $summary.closest('.jdgm-rev-widg').find('.jdgm-rev-widg__summary-inner');
            if ($summaryInner.length > 0 && !$summaryInner.find('.rating-value').length) {
                $summaryInner.prepend('<span class="rating-value">' + rating + '</span>');
            }
        }
    }
}

// ==========================================
// JDGM REVIEW BODY TRUNCATION
// If .jdgm-review-content__body-content has > 23 words, truncate and add expand button
// ==========================================
function truncateJdgmReviewBodies(root) {
    var $root = root ? $(root) : $(document);
    $root.find('.jdgm-review-content__body-content').each(function() {
        var $el = $(this);

        // Skip if already processed
        if ($el.hasClass('sg-truncated')) return;

        var fullText = $el.text().trim();
        var words = fullText.split(/\s+/);
        if (words.length <= 22) return;

        // Store full text for expansion
        $el.attr('data-full-text', fullText);

        var truncated = words.slice(0, 22).join(' ') + '…';
        $el.text(truncated);
        $el.addClass('sg-truncated');

        var $btn = $(
            '<button class="jm-review-content__expand-button" type="button" aria-expanded="false">' +
            '<p class="jm-text" style="--text-size: var(--jm-body-md-size); --text-weight: var(--jm-body-md-weight-bold);">More</p>' +
            '</button>'
        );

        // Insert button after .jm-review-body-wrapper (parent wrapper), not after $el
        var $wrapper = $el.closest('.jm-review-body-wrapper');
        var $insertAfter = $wrapper.length ? $wrapper : $el;

        // Only insert button if one doesn't already exist after the target
        if ($insertAfter.next('.jm-review-content__expand-button').length > 0) return;

        $insertAfter.after($btn);

        $btn.on('click', function() {
            var expanded = $(this).attr('aria-expanded') === 'true';
            if (expanded) {
                $el.text(words.slice(0, 22).join(' ') + '…');
                $(this).attr('aria-expanded', 'false');
                $(this).find('.jm-text').text('More');
            } else {
                $el.text($el.attr('data-full-text'));
                $(this).attr('aria-expanded', 'true');
                $(this).find('.jm-text').text('Less');
            }
        });
    });
}

// Fallback truncation for initial load (MutationObservers handle dynamic content)
document.addEventListener('jdgm.doneSetup', function() {
    setTimeout(function() { truncateJdgmReviewBodies(); }, 400);
});

window.addEventListener('load', function() {
    setTimeout(function() { truncateJdgmReviewBodies(); }, 600);
});
